module.exports = __webpack_public_path__ + "static/media/Crunch It Menu v2.7f62d813.jpg";